/*
 *
 * lv1_0_1    lv1代表关卡1, 0,0代表坐标
 */

export const levelList = {
  lv1_0_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv1_0_0.png",
  lv1_0_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv1_0_1.png",
  lv1_1_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv1_1_0.png",
  lv1_1_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv1_1_1.png",
  lv2_0_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv2_0_0.png",
  lv2_0_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv2_0_1.png",
  lv2_1_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv2_1_0.png",
  lv2_1_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv2_1_1.png",
  lv2_2_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv2_2_0.png",
  lv3_0_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv3_0_0.png",
  lv3_0_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv3_0_1.png",
  lv3_1_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv3_1_0.png",
  lv3_1_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv3_1_1.png",
  lv3_2_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv3_2_0.png",
  lv3_2_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv3_2_1.png",
  lv4_0_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv4_0_0.png",
  lv4_0_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv4_0_1.png",
  lv4_0_2:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv4_0_2.png",
  lv4_1_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv4_1_0.png",
  lv4_1_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv4_1_1.png",
  lv4_1_2:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv4_1_2.png",
  lv4_2_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv4_2_0.png",
  lv5_0_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv5_0_0.png",
  lv5_0_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv5_0_1.png",
  lv5_0_2:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv5_0_2.png",
  lv5_1_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv5_1_0.png",
  lv5_1_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv5_1_1.png",
  lv5_1_2:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv5_1_2.png",
  lv5_2_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv5_2_0.png",
  lv5_2_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv5_2_1.png",
  lv6_0_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv6_0_0.png",
  lv6_0_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv6_0_1.png",
  lv6_0_2:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv6_0_2.png",
  lv6_1_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv6_1_0.png",
  lv6_1_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv6_1_1.png",
  lv6_1_2:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv6_1_2.png",
  lv6_2_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv6_2_0.png",
  lv6_2_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv6_2_1.png",
  lv6_2_2:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv6_2_2.png",
  lv7_0_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv7_0_0.png",
  lv7_0_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv7_0_1.png",
  lv7_0_2:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv7_0_2.png",
  lv7_1_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv7_1_0.png",
  lv7_1_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv7_1_1.png",
  lv7_1_2:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv7_1_2.png",
  lv7_2_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv7_2_0.png",
  lv7_2_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv7_2_1.png",
  lv7_2_2:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv7_2_2.png",
  lv7_3_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv7_3_0.png",
  lv8_0_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv8_0_0.png",
  lv8_0_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv8_0_1.png",
  lv8_0_2:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv8_0_2.png",
  lv8_1_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv8_1_0.png",
  lv8_1_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv8_1_1.png",
  lv8_1_2:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv8_1_2.png",
  lv8_2_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv8_2_0.png",
  lv8_2_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv8_2_1.png",
  lv8_2_2:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv8_2_2.png",
  lv8_3_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv8_3_0.png",
  lv8_3_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv8_3_1.png",
  lv9_0_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv9_0_0.png",
  lv9_0_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv9_0_1.png",
  lv9_0_2:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv9_0_2.png",
  lv9_1_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv9_1_0.png",
  lv9_1_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv9_1_1.png",
  lv9_1_2:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv9_1_2.png",
  lv9_2_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv9_2_0.png",
  lv9_2_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv9_2_1.png",
  lv9_2_2:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv9_2_2.png",
  lv9_3_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv9_3_0.png",
  lv9_3_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv9_3_1.png",
  lv9_3_2:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv9_3_2.png",
  lv10_0_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv10_0_0.png",
  lv10_0_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv10_0_1.png",
  lv10_0_2:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv10_0_2.png",
  lv10_1_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv10_1_0.png",
  lv10_1_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv10_1_1.png",
  lv10_1_2:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv10_1_2.png",
  lv10_2_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv10_2_0.png",
  lv10_2_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv10_2_1.png",
  lv10_2_2:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv10_2_2.png",
  lv10_3_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv10_3_0.png",
  lv10_3_1:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv10_3_1.png",
  lv10_3_2:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv10_3_2.png",
  lv10_4_0:
    "https://sudiaoba.oss-cn-beijing.aliyuncs.com/assets/images/fragment/lv10_4_0.png"
};
